import Chip from "@material-ui/core/Chip";
import styled from "styled-components";

const TMCChip = styled(Chip)`
  margin-right: 4px;
  font-family: ${({ theme }) => theme.fonts.main};
`;
export default TMCChip;
